module.exports = __webpack_public_path__ + "img/text_6.81c2dcc8.svg";